module.exports = __webpack_public_path__ + "static/media/second.8de20020.jpeg";